import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

export const Title = styled.h2`
	font-size: 16px;
	font-weight: 600;
	text-align: center;
	color: ${tokens.color_ink_light};
`;

export const Description = styled.p`
	padding: 24px 0;
	color: ${tokens.color_ink_light};
`;

export const ContainerUpload = styled.div`
	padding-bottom: 32px;
	width: 100%;

	& div {
		width: unset;
	}

	span {
		max-width: 170px;
	}

	label,
	input {
		height: 100%;
		width: 100%;
	}
`;

export const ContainerButton = styled.div`
	display: flex;
	justify-content: space-between;

	gap: 20px;

	button {
		width: 50%;
	}
`;
